import * as React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useTranslation } from "react-i18next";

interface Props {
    onCreateScheduleEntry: () => void;
    onCreateFieldServiceEntry: () => void;
    onCreateSpeechEntry: () => void;
    disableSpeech?: boolean;
}

const ScheduleCreateEntryMenu = ({
    onCreateScheduleEntry,
    onCreateFieldServiceEntry,
    onCreateSpeechEntry,
    disableSpeech = true,
}: Props) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const callAndClose = (callback: () => void) => {
        handleClose();
        callback();
    };

    return (
        <>
            <Button color="inherit" type="button" onClick={handleOpen}>
                {t("create_entry")}
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={() => callAndClose(onCreateScheduleEntry)}>
                    {t("basic_schedule_entry")}
                </MenuItem>
                <MenuItem onClick={() => callAndClose(onCreateFieldServiceEntry)}>
                    {t("field_service")}
                </MenuItem>
                <MenuItem disabled={disableSpeech} onClick={() => callAndClose(onCreateSpeechEntry)}>
                    {t("speech")}
                </MenuItem>
            </Menu>
        </>
    );
};

export default ScheduleCreateEntryMenu;
